import React, { useEffect, useState } from "react";
import CommonButton from "../Common/Button";
import FormInput from "../Common/FormInput";
import TextArea from "../Common/TextArea";
import DateSelect from "../Common/DateSelector";
import {
  FormGroup,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
} from "reactstrap";
import FlexCol from "../Common/FlexCol";
import { Flex, notification } from "antd";
import { Formik, useFormik } from "formik";
import * as Yup from "yup";
import API, { action } from "../../Api";
import DropdownButton from "../Common/DropdownButton";
import MultiSelector from "../Common/MultiSelector";
import Label from "../Common/Label";
import { IoMdClose } from "react-icons/io";

function RecordVaccine({ isOpen, toggle, selectedData }) {
  // console.log(selectedData, "selectedData");
  const [cattleid, setCattleid] = useState([]);
  const tabs = ["Type A", "Type B", "Type C"];
  const [activeTab, setActiveTab] = useState("Type A");
  const [activeTab2, setActiveTab2] = useState("No"); // For "Need Medicine" tab
  const tabs2 = ["Yes", "No"];
  const id = localStorage.getItem("userid");
  const [searchKey, setSearchKey] = useState("");
  const [loading, setLoading] = useState(false);
  const isDisabled = !!selectedData;

  // console.log(activeTab, "active tab");

  useEffect(() => {
    if (isOpen && !selectedData) {
      setActiveTab("Type A");
    }
  }, [isOpen, selectedData]);

  const healthstatusOption = [
    { value: "critical", label: "Critical" },
    { value: "normal", label: "Normal" },
    { value: "major", label: "Major" },
  ];

  const getCattleId = async () => {
    try {
      const result = await action(API.GET_CATTLE_ID, {
        searchKey: searchKey,
        page: 1,
        pageCount: 60,
      });
      const cattleID = result.response.data.map((id) => ({
        label: id.cattle_id, // Display name
        value: id.cattle_id, // Unique identifier
      }));
      setCattleid(cattleID); // Set data with both label and value
    } catch (error) {
      console.error("Error fetching cattle data:", error);
    }
  };

  useEffect(() => {
    getCattleId();
  }, [searchKey]);

  // Validation Schema using Yup
  // Change: cattle must be an array of strings, required, at least one selected
  const validationSchema = Yup.object({
    vaccineName: Yup.string().required("Vaccine Name is required"),
    dosage: Yup.string().required("Dosage is required"),
    vaccineDate: Yup.date().required("Vaccination Date is required"),
    cattle: Yup.array()
      .of(Yup.string())
      .min(1, "Cattle is required")
      .required("Cattle is required"),
    healthStatus: Yup.string().required("Health Status is required"),
    // description: Yup.string().required('Description is required'),
  });

  const formik = useFormik({
    initialValues: {
      vaccineName: "",
      dosage: "",
      vaccineDate: "",
      cattle: [], // Change: default to empty array for multi-select
      healthStatus: "normal",
      nextvaccineDate: "",
      medicineName: "",
      medicineDosage: "",
      description: "",
    },

    validationSchema: selectedData ? null : validationSchema,

    onSubmit: async (values) => {
      setLoading(true);
      try {
        if (selectedData) {
          // Update existing vaccination record
          const result = await action(API.UPDATE_VACCINATION, {
            id: selectedData[0]?.id,
            status: "recorded",
          });

          notification.success({
            message: result.response.message,
            placement: "top",
          });
          formik.resetForm();
          toggle();
        } else {
          await action(API.ADD_VACCINATION, {
            cattle_id: values.cattle, // Now an array
            vaccination_type: activeTab,
            vaccination_name: values.vaccineName,
            dosage: values.dosage,
            vaccination_date: values.vaccineDate,
            health_status: values.healthStatus,
            next_vaccination_date: values.nextvaccineDate,
            medicine_name: values.medicineName,
            medicine_dosage: values.medicineDosage,
            description: values.description,
            status: "assigned",
            created_by: id,
          });
          notification.success({
            message: "Record vaccination added successfully",
            placement: "top",
          });
          formik.resetForm();
          toggle();
        }
      } catch (error) {
        console.error(error);
        let errorMessage = "Failed to assign vaccination";
        
        // Handle different error response structures
        if (error.response?.data?.response?.message) {
          errorMessage = error.response.data.response.message;
        } else if (error.response?.data?.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        } else if (error.response?.statusText) {
          errorMessage = error.response.statusText;
        }

        notification.error({
          message: errorMessage,
          placement: "top",
        });
      } finally {
        setLoading(false);
      }
    },
  });

  // console.log(formik.errors, "formik values");

  useEffect(() => {
    if (selectedData && selectedData.length > 0) {
      // Set basic fields
      formik.setFieldValue("healthStatus", selectedData[0]?.HealthStatus);
      formik.setFieldValue("vaccineDate", selectedData[0]?.LastVaccinated);

      // If CattleID is a string, wrap in array; if already array, use as is
      let cattleValue = selectedData[0]?.CattleID;
      if (Array.isArray(cattleValue)) {
        formik.setFieldValue("cattle", cattleValue);
      } else if (typeof cattleValue === "string" && cattleValue) {
        // If comma separated string, split
        if (cattleValue.includes(",")) {
          formik.setFieldValue(
            "cattle",
            cattleValue.split(",").map((s) => s.trim())
          );
        } else {
          formik.setFieldValue("cattle", [cattleValue]);
        }
      } else {
        formik.setFieldValue("cattle", []);
      }

      formik.setFieldValue("vaccineName", selectedData[0]?.VaccinationName);
      formik.setFieldValue("dosage", selectedData[0]?.dosage);
      formik.setFieldValue("nextvaccineDate", selectedData[0]?.NextVaccination);
      formik.setFieldValue("activeTab", selectedData[0]?.vaccination_type);
      formik.setFieldValue("slot", selectedData[0]?.slot);
      formik.setFieldValue("description", selectedData[0]?.Description);
    }
    // eslint-disable-next-line
  }, [selectedData]);

  const toggle1 = () => {
    formik.resetForm();
    formik.setErrors({});
    formik.setTouched({});
    setActiveTab("Type A");
    setActiveTab2("No");
    setSearchKey("");
    // setCattleid([]);
    toggle();
  };

  useEffect(() => {
    if (selectedData?.[0]?.vaccination_type) {
      setActiveTab(selectedData[0].vaccination_type);
    } else if (isOpen) {
      setActiveTab("Type A");
    }
  }, [isOpen, selectedData]);

  return (
    <Offcanvas
      isOpen={isOpen}
      toggle={toggle1}
      direction="end"
      className=" w-full md:!w-[320px] 2xl:!w-[480px] max-h-full overflow-y-auto"
    >
      <button
        type="button"
        onClick={toggle1}
        aria-label="Close"
        style={{
          position: "absolute",
          top: 12,
          right: 12,
          zIndex: 1001,
          background: "transparent",
          border: "none",
          cursor: "pointer",
          padding: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <IoMdClose size={18} color="#333" />
      </button>
      <FlexCol className="p-4">
        <OffcanvasHeader>
          <div>
            <div className="text-[16px] font-semibold 2xl:text-2xl text-[#09090B] leading-[21.6px] break-words font-plus-jakarta-sans">
              Record Vaccine
            </div>
            <div className="text-[10px] 2xl:text-sm text-[#726C6C] font-plus-jakarta-sans">
              Provide vaccination data and follow-up.
            </div>
          </div>
        </OffcanvasHeader>

        <OffcanvasBody>
          <form onSubmit={formik.handleSubmit}>
            <FormGroup>
              {!isDisabled ? (
                <FlexCol className="" gap={20}>
                  <Flex className="grid grid-cols-1 gap-[30px] items-center">
                    <FormInput
                      title="Vaccine Name"
                      placeholder="Enter Vaccine Name"
                      value={formik.values.vaccineName}
                      change={(value) =>
                        formik.setFieldValue("vaccineName", value)
                      }
                      error={
                        formik.errors.vaccineName && formik.touched.vaccineName
                          ? formik.errors.vaccineName
                          : null
                      }
                      disabled={isDisabled}
                      required={true}
                    />

                    <FormInput
                      title="Dosage (mg/bwt)"
                      type="number"
                      placeholder="Enter Dosage"
                      value={formik.values.dosage}
                      change={(value) => formik.setFieldValue("dosage", value)}
                      error={
                        formik.errors.dosage && formik.touched.dosage
                          ? formik.errors.dosage
                          : null
                      }
                      disabled={isDisabled}
                      required={true}
                      maxLength={4}
                    />

                    <DateSelect
                      title="Vaccination Date"
                      placeholder="Choose Vaccination Date"
                      value={formik.values.vaccineDate}
                      change={(value) =>
                        formik.setFieldValue("vaccineDate", value)
                      }
                      error={
                        formik.errors.vaccineDate && formik.touched.vaccineDate
                          ? formik.errors.vaccineDate
                          : null
                      }
                      disabled={isDisabled}
                      required={true}
                      disableBeforeDate={new Date().toISOString().split("T")[0]}
                    />

                    <MultiSelector
                      title="Cattle"
                      placeholder="Select Cattle"
                      options={cattleid}
                      value={formik.values.cattle}
                      onSearch={setSearchKey}
                      onChange={(value) => {
                        // Always set as array
                        formik.setFieldValue("cattle", value || []);
                        setSearchKey("");
                      }}
                      onDropdownVisibleChange={(open) => {
                        if (!open) {
                          setSearchKey("");
                        }
                      }}
                      error={
                        formik.errors.cattle && formik.touched.cattle
                          ? formik.errors.cattle
                          : null
                      }
                      disabled={isDisabled}
                      required={true}
                      mode="multiple"
                    />

                    <DropdownButton
                      title="Health Status"
                      placeholder="Select Health Status"
                      value={formik.values.healthStatus}
                      change={(value) =>
                        formik.setFieldValue("healthStatus", value)
                      }
                      options={healthstatusOption}
                      error={
                        formik.errors.healthStatus &&
                        formik.touched.healthStatus
                          ? formik.errors.healthStatus
                          : null
                      }
                      disabled={isDisabled}
                      required={true}
                      SelectName="Select Health Status"
                    />
                    {!selectedData && (
                      <DateSelect
                        title="Next Vaccination Date"
                        placeholder="Choose Next Vaccination Date"
                        value={formik.values.nextvaccineDate}
                        change={(value) =>
                          formik.setFieldValue("nextvaccineDate", value)
                        }
                        disabled={isDisabled}
                        disableBeforeDate={formik.values.vaccineDate}
                      />
                    )}
                    <TextArea
                      title="Description"
                      placeholder="Enter Description"
                      value={formik.values.description}
                      change={(value) =>
                        formik.setFieldValue("description", value)
                      }
                      // error={formik.errors.description && formik.touched.description ? formik.errors.description : null}
                      // required= {true}
                      disabled={isDisabled}
                    />
                  </Flex>
                </FlexCol>
              ) : (
                <>
                  <Label
                    title="Vaccine Name"
                    value={formik.values.vaccineName || ""}
                  />
                  <Label
                    title="Dosage (mg/bwt)"
                    value={formik.values.dosage || ""}
                  />
                  <Label
                    title="Vaccination Date"
                    value={formik.values.vaccineDate || ""}
                  />
                  <Label
                    title="Cattle"
                    value={
                      Array.isArray(formik.values.cattle)
                        ? formik.values.cattle.join(", ")
                        : formik.values.cattle || ""
                    }
                  />
                  <Label
                    title="Health Status"
                    value={formik.values.healthStatus || "--"}
                  />
                  <Label
                    title="Next Vaccination Date"
                    value={formik.values.nextvaccineDate || "--"}
                  />
                  <Label
                    title="Description"
                    value={formik.values.description || "--"}
                  />
                </>
              )}
            </FormGroup>

            <div className="flex justify-between mt-8">
              <CommonButton
                style={{
                  backgroundColor: "none",
                  color: "#726C6C",
                  border: "1px #CCCBCB solid",
                  marginRight: "8px",
                  fontSize: "12px",
                }}
                onClick={toggle1}
                outline
                title="Discard"
                disabled={loading}
              />
              {selectedData?.[0]?.status !== "recorded" && (
                <CommonButton
                  title={
                    selectedData ? "Record Vaccination" : "Assign Vaccination"
                  }
                  type="submit"
                  style={{
                    fontSize: "12px",
                  }}
                  disabled={loading}
                />
              )}
            </div>
          </form>
        </OffcanvasBody>
      </FlexCol>
    </Offcanvas>
  );
}

export default RecordVaccine;
